import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';

export const notif = new Notyf({
    duration: 3000,
    position: {
        x: 'right',
        y: 'top',
    },
    types: [
        {
          type: 'info',
          background: 'white',
          textColor: 'gray', 
          BorderColor: 'gray',  
          duration: 0,
          dismissible: false
        },
        {
          type: 'warning',
          background: 'orange',
          icon: {
            className: 'material-icons',
            tagName: 'i',
            text: 'warning'
          }
        },
        {
          type: 'error',
          background: 'indianred',
          duration: 2000,
          dismissible: true
        }
      ]
});



